<template>
  <v-container v-resize="onResize">
    <v-row>
      <v-col cols="12">
        <div class="_title">
          <v-icon small> mdi-magnify </v-icon>
          {{ $t('rtrck.title.summary.detail') }}
        </div>
      </v-col>
    </v-row>
    <progress-linear :active="loading"></progress-linear>
    <v-row>
      <v-col cols="12">
        <v-card class="card-wrap">
          <div class="box">
            <v-row>
              <v-col cols="2">
                <v-row>
                  <v-col cols="12">
                    <span>{{ $t('rtrck.system') }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="4">
                <v-row>
                  <v-col cols="6">
                    <span v-if="showUser">{{ $t('rtrck.field.title.bname') }}</span>
                    <span v-if="showRole">{{ $t('rtrck.field.title.agr.name') }}</span>
                    <span v-if="showProfile">{{ $t('rtrck.field.title.profn') }}</span>
                  </v-col>
                  <v-col cols="6">
                    <span v-if="showUser">{{ $t('rtrck.field.title.created.by') }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6"> </v-col>
            </v-row>
            <v-row>
              <v-col cols="2">
                <v-row>
                  <v-col cols="12">
                    <v-text-field :value="systemId" class="text-full-width" outlined dense hide-details readonly></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="4">
                <v-row>
                  <v-col cols="6">
                    <v-text-field v-if="showUser" v-model="userName" class="text-full-width" outlined dense hide-details></v-text-field>
                    <v-text-field v-if="showRole" v-model="roleName" class="text-full-width" outlined dense hide-details></v-text-field>
                    <v-text-field v-if="showProfile" v-model="profileName" class="text-full-width" outlined dense hide-details></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-if="showUser" v-model="createdBy" class="text-full-width" outlined dense hide-details></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row>
                  <v-col cols="12">
                    <div>
                      <v-btn @click="paging = { page: 1, rowsPerPage: paging.rowsPerPage }" color="primary" x-small class="icon-right">
                        <v-icon small>mdi-magnify</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="item-title">
          <h2>
            <img v-if="'USER' == this.keyTag" src="@/assets/image/diagram/node_user_icon.png" class="item-image" />
            <img v-if="'CROL' == this.keyTag" src="@/assets/image/diagram/node_composite_role_icon.png" class="item-image" />
            <img v-if="'SROL' == this.keyTag" src="@/assets/image/diagram/node_single_role_icon.png" class="item-image" />
            <img v-if="'CPRF' == this.keyTag" src="@/assets/image/diagram/node_composite_profile_icon.png" class="item-image" />
            <img v-if="'SPRF' == this.keyTag" src="@/assets/image/diagram/node_single_profile_icon.png" class="item-image" />
            <span v-html="`${title}`" />
          </h2>
        </div>
      </v-col>
    </v-row>
    <v-row style="height: calc(100% - 210px)">
      <v-col cols="12">
        <v-data-table :headers="headers" :items="rows" item-key="key" :options.sync="options" :items-per-page="paging.rowsPerPage" :loading="loading" :height="height" class="elevation-1 content" must-sort fixed-header dense hide-default-footer>
          <template v-slot:item.lockStatus="{ item }"> {{ $t(`cd.039.${item.lockStatus}`) }} </template>
          <template v-slot:item.pwdState="{ item }"> {{ $t(`cd.073.${item.pwdState}`) }} </template>
          <template v-slot:item.lastLogonYmdhms="{ item }"> {{ item.lastLogonYmdhms | format('yyyy-MM-dd HH:mm:ss') }} </template>
          <template v-slot:item.validPeriod="{ item }"> {{ item.validFromYmd | format('yyyy-MM-dd') }} ~ {{ item.validToYmd | format('yyyy-MM-dd') }}</template>
          <template v-slot:item.statusColor="{ item }"><v-icon small :style="cssStatusColor(item.statusColor)">mdi-circle</v-icon></template>
          <template v-slot:item.changeDatim="{ item }"> {{ item.changeDatim | format('yyyy-MM-dd HH:mm:ss') }} </template>
          <template v-slot:item.modDatim="{ item }"> {{ item.modDatim | format('yyyy-MM-dd HH:mm:ss') }} </template>
          <template v-slot:item.tcodeCnt="{ item }"> {{ item.tcodeCnt | comma }} </template>
          <template #footer>
            <pagination :paging.sync="paging" :length="length" :disabled="loading"></pagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import { format, subMonths, startOfDay, endOfDay, parseISO } from 'date-fns';
import { api } from '@/api/common/instances';
import share from './summaryShare.js';
export default {
  mixins: [share],
  data() {
    return {
      imgSrcBase: '@/assets/image/diagram/',
      systemId: this.$route.query.sstm,
      userName: '',
      createdBy: '',
      roleName: '',
      profileName: '',
      options: {},
      length: 0,
      paging: { page: 1, rowsPerPage: 100 },
      loading: false,
      height: 0,
      rows: [],
    };
  },
  computed: {
    keyTag() {
      return this.$route.query.key.split('_')[0];
    },
    keyIdx() {
      return parseInt(this.$route.query.key.split('_')[1]);
    },
    showUser() {
      if ('USER' == this.keyTag) return true;
      else return false;
    },
    showRole() {
      if ('ROL' == this.keyTag.substring(1)) return true;
      else return false;
    },
    showProfile() {
      if ('PRF' == this.keyTag.substring(1)) return true;
      else return false;
    },
    title() {
      if ('USER' == this.keyTag) return this.users[this.keyIdx].text;
      if ('CROL' == this.keyTag) return this.crols[this.keyIdx].text;
      if ('SROL' == this.keyTag) return this.srols[this.keyIdx].text;
      if ('CPRF' == this.keyTag) return this.cprfs[this.keyIdx].text;
      if ('SPRF' == this.keyTag) return this.sprfs[this.keyIdx].text;
      return '';
    },
    headers() {
      let headers;
      if ('USER' == this.keyTag)
        headers = [
          { text: this.$t('rtrck.field.title.mandt'), sortable: true, value: 'mandt', width: '6%' },
          { text: this.$t('rtrck.field.title.bname'), sortable: true, value: 'bname', width: '10%' },
          { text: this.$t('rtrck.field.title.user.type'), sortable: true, value: 'type.name', width: '10%', align: 'center' },
          { text: this.$t('rtrck.field.title.lock.status'), sortable: true, value: 'lockStatus', width: '10%', align: 'center' },
          { text: this.$t('rtrck.field.title.pwd.state'), sortable: true, value: 'pwdState', width: '12%', align: 'center' },
          { text: this.$t('rtrck.field.title.last.logon'), sortable: true, value: 'lastLogonYmdhms', width: '14%', align: 'center' },
          { text: this.$t('rtrck.field.title.valid.period'), sortable: true, value: 'validPeriod', align: 'center' },
          { text: this.$t('rtrck.field.title.created.by'), sortable: true, value: 'createdBy', width: '10%' },
          { text: this.$t('rtrck.field.title.tcode.cnt'), sortable: true, value: 'tcodeCnt', width: '10%', align: 'end' },
        ];
      if ('ROL' == this.keyTag.substring(1))
        headers = [
          { text: this.$t('rtrck.field.title.mandt'), sortable: true, value: 'mandt', width: '6%' },
          { text: this.$t('rtrck.field.title.agr.name'), sortable: true, value: 'agrName', width: '20%' },
          { text: this.$t('rtrck.field.title.role.status'), sortable: true, value: 'statusColor', width: '10%', align: 'center' },
          { text: this.$t('rtrck.field.title.change.usr'), sortable: true, value: 'changeUsr', width: '10%' },
          { text: this.$t('rtrck.field.title.change.datim'), sortable: true, value: 'changeDatim', width: '10%', align: 'center' },
          { text: this.$t('rtrck.field.title.tcode.cnt'), sortable: true, value: 'tcodeCnt', width: '10%', align: 'end' },
        ];
      if ('PRF' == this.keyTag.substring(1))
        headers = [
          { text: this.$t('rtrck.field.title.mandt'), sortable: true, value: 'mandt', width: '6%' },
          { text: this.$t('rtrck.field.title.profn'), sortable: true, value: 'profn', width: '20%' },
          { text: this.$t('rtrck.field.title.modebe'), sortable: true, value: 'modebe', width: '10%' },
          { text: this.$t('rtrck.field.title.mod.datim'), sortable: true, value: 'modDatim', width: '10%', align: 'center' },
          { text: this.$t('rtrck.field.title.tcode.cnt'), sortable: true, value: 'tcodeCnt', width: '10%', align: 'end' },
        ];
      return headers;
    },
  },
  watch: {
    paging: {
      deep: true,
      handler() {
        this.fetchData();
      },
    },
  },
  methods: {
    cssStatusColor(statusColor) {
      if ('G' == statusColor) return 'color:green';
      if ('Y' == statusColor) return 'color:yellow';
      if ('R' == statusColor) return 'color:red';
      return 'color:white';
    },
    // lockStatusLabel(lockStatus) {
    //   return this.$t(`cd.039.${lockStatus}`);
    // },
    async fetchData() {
      this.loading = true;
      let lastUri, params;
      let baseParams = {
        svrYmdhms: this.$route.query.ymd,
        sstmId: this.$route.query.sstm,
        mandt: this.$route.query.mand,
        srchBgnYmd: this.$route.query.stim,
        srchEndYmd: this.$route.query.etim,
        rowKey: this.$route.query.key,
        page: this.paging.page,
        limit: this.paging.rowsPerPage,
      };
      if ('USER' == this.keyTag) {
        lastUri = 'user-list';
        params = {
          ...baseParams,
          bname: this.userName,
          aname: this.createdBy,
        };
      }
      if ('ROL' == this.keyTag.substring(1)) {
        lastUri = 'role-list';
        params = {
          ...baseParams,
          agrName: this.roleName,
        };
      }
      if ('PRF' == this.keyTag.substring(1)) {
        lastUri = 'profile-list';
        params = {
          ...baseParams,
          profn: this.profileName,
        };
      }
      // eslint-disable-next-line prettier/prettier
      const { data: { items, pagination }} = await api.get(`/rtrck/summary/${lastUri}`, {
        params: params,
      });
      this.rows = items;
      this.length = pagination.totalCount;
      this.loading = false;
    },
    onResize() {
      this.height = window.innerHeight - 210;
    },
  },
  async created() {
    await this.fetchData();
  },
};
</script>

<style scoped>
.container {
  padding: 0 10px 10px 10px;
  margin: 0;
  max-width: 100%;
}
._title {
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2;
}
.item-title {
  float: left;
  height: 40px;
  line-height: 20px;
}
.item-image {
  height: 20px;
  width: 20px;
  vertical-align: middle;
  margin: 10px;
}
.text-full-width {
  width: auto;
}
.icon-right {
  float: right;
}
</style>
